import { Routes, Route, Navigate } from "react-router-dom";
import Domestic from "./Domestic";

const domesticRoutes = [
  { routeName: "overnight", component: <Domestic /> },
  { routeName: "samedaydelivery", component: <Domestic /> },
  { routeName: "2nddaydelivery", component: <Domestic /> },
  { routeName: "timechoicedelivery", component: <Domestic /> },
  { routeName: "redbox", component: <Domestic /> },
  { routeName: "economyexpress", component: <Domestic /> },
  { routeName: "expressflyer", component: <Domestic /> },
  { routeName: "mehfoozexpress", component: <Domestic /> },
  { routeName: "liquidshipping", component: <Domestic /> },
  { routeName: "studentexpress", component: <Domestic /> },
  { routeName: "attestationservices", component: <Domestic /> },
  { routeName: "ticketingservices", component: <Domestic /> },
  { routeName: "retail_cod", component: <Domestic /> },
  { routeName: "paymentsolution", component: <Domestic /> },
  { routeName: "shipmentinsurance", component: <Domestic /> },
  { routeName: "tcsfresh", component: <Domestic /> },
  { routeName: "ecomsolution", component: <Domestic /> },
  { routeName: "mms", component: <Domestic /> },
  { routeName: "overlandexpress", component: <Domestic /> },
  { routeName: "Warehousing", component: <Domestic /> },
  { routeName: "distribution", component: <Domestic /> },
  { routeName: "pack-n-go", component: <Domestic /> },
  { routeName: "coldchain", component: <Domestic /> },
];

const DomesticRoutes = () => {
  return (
    <Routes>
      {domesticRoutes.map((route, key) => (
        <Route
          key={key}
          path={route.routeName}
          element={route.component}
        ></Route>
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default DomesticRoutes;
